import { useState, useEffect } from "react";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import FloatingChatButton from "../components/FloatingChatButton";
import ChatWidget from "../components/Chat";
import { Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

export default function MainLayout({ headerText }) {
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [chatData, setChatData] = useState(null);
  const location = useLocation();
  const [pageKey, setPageKey] = useState(location.key);

  // Access the user and helper methods directly
  const { user, authFetch } = useAuth();

  // EFFECT: Fetch chat data
  // Logic: If chat is closed, data is missing, and user exists -> Pre-fetch data
  useEffect(() => {

    const fetchChatData = async () => {
      // Safety check to ensure user exists before fetching
      if (!user?.id) return;

      console.log("Fetching chat data...");

      const messagesEndpoint = `${process.env.REACT_APP_API_URL}/api/chat/users/${user.id}/chats/latest`;

      console.log("messagesEndpoint: ", messagesEndpoint);

      try {
        const response = await authFetch(messagesEndpoint);
        const data = await response.json();

        console.log("Chat data fetched: ", data);

        if (data) {
          setChatData(data);
        }
      } catch (err) {
        console.error("Error fetching chat:", err);
      }
    };

    // Only run if chat is NOT open and we don't have data yet
    if (!chatData) {
      fetchChatData();
    }

    // Dependencies: Run this effect when these values change
  }, [chatData, user, authFetch]);

  const handleChatToggle = () => {
    setIsChatOpen((prev) => !prev);
    console.log("Chat toggled. New state:", !isChatOpen);
  };

  useEffect(() => {
    setPageKey(location.key);
  }, [location.key]);

  return (
    <div className="min-h-screen bg-[#EDF0F2] font-sans text-[#323334] flex">
      {/* Sidebar fijo */}
      <Sidebar />

      {/* Contenido principal */}
      <div key={pageKey} className="flex-1 ml-0 lg:ml-[302px] p-4 sm:p-6 mt-10 lg:mt-0 animate-fade-in">
        <div className="flex items-center justify-between px-0 sm:px-6">
          <h2 className="text-xl sm:text-2xl font-semibold">{headerText}</h2>
          <Header />
        </div>

        <Outlet context={{ chatData }} />
      </div>

      {/* Botón flotante */}
      {/* <FloatingChatButton onClick={handleChatToggle} /> */}

      {/* Chat flotante funcional */}

    </div>
  );
}